import { signOut } from "firebase/auth";
import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom";
import auth from "../../firebase.init";
import './Header.css';

const Header = () => {
  const [user] = useAuthState(auth);
  const handleSignOut =()=>{
    signOut(auth);
  }
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-info mb-5 sticky-top">
      <div className="container-fluid ">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <ul className="navbar-nav header-menu">
           <li className="nav-item">
              <Link className="nav-link" to="/home">
                Home
              </Link>
              </li>
           
              
              <li className="nav-item">
           
              <Link className="nav-link" to="/blog">
                Blog
              </Link>
              </li>
              <li className="nav-item">
           
              <Link className="nav-link" to="/checkout">
                Checkout
              </Link>
              </li>
             
              <li className="nav-item">
              <Link className="nav-link" to="/about">
                About
              </Link> </li>
              {
                user? 
                <button className='btn btn-link signout-btn' onClick={handleSignOut}>Sign Out</button> :
                
              <li className="nav-item">
              <Link className="nav-link" to="/login">
                Login
              </Link> </li>
              }
            
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
